import React from 'react';

export function PinLocationIcon(): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M7.6875 6.53125C7.6875 7.14456 7.93114 7.73276 8.36482 8.16643C8.79849 8.60011 9.38669 8.84375 10 8.84375C10.6133 8.84375 11.2015 8.60011 11.6352 8.16643C12.0689 7.73276 12.3125 7.14456 12.3125 6.53125C12.3125 5.91794 12.0689 5.32974 11.6352 4.89607C11.2015 4.46239 10.6133 4.21875 10 4.21875C9.38669 4.21875 8.79849 4.46239 8.36482 4.89607C7.93114 5.32974 7.6875 5.91794 7.6875 6.53125Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 1.32812C11.38 1.32813 12.7034 1.87631 13.6792 2.85209C14.6549 3.82786 15.2031 5.1513 15.2031 6.53125C15.2031 9.03723 11.2472 14.6458 10.2343 16.041C10.2073 16.0778 10.1721 16.1078 10.1313 16.1284C10.0906 16.149 10.0456 16.1598 10 16.1598C9.95436 16.1598 9.90936 16.149 9.86865 16.1284C9.82794 16.1078 9.79266 16.0778 9.76567 16.041C8.75279 14.6458 4.79688 9.03723 4.79688 6.53125C4.79687 5.1513 5.34506 3.82786 6.32084 2.85209C7.29661 1.87631 8.62005 1.32813 10 1.32812Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6088 14.459C16.7147 14.876 18.0938 15.5721 18.0938 16.3599C18.0938 17.6371 14.4708 18.6724 10 18.6724C5.52917 18.6724 1.90625 17.6371 1.90625 16.3599C1.90625 15.5736 3.2791 14.8791 5.375 14.4613'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
